import search from './api/search';

const Center = {
  centers: [],
  kind: 0,
  position: 0,
  boundLength: 0,
  length: 0,
  keyword: '',
  setKind: (kind) => {
    Center.kind = kind;
  },
  setKeyword: (keyword) => {
    Center.keyword = keyword;
  },
  moveLocation: (bound, keywords, callback) => {
    const areaRect = Center.getBoundRect(bound);

    if (keywords.length >= 0) {
      Center.setKeyword(keywords);
    }

    if ((!Center.keyword || Center.keyword.length === 0)) {
      Center.keyword = [];
    }

    search.searchByKeyword(Center.kind, areaRect, Center.keyword, (status, resData) => {
      const centerResponse = resData;
      Center.centers = resData.centers || [];
      Center.length = Center.centers.length;
      Center.boundLength = Center.length > 20 ? 20 : Center.length;

      const pl = Math.ceil(Center.length / 10);
      const ppl = Math.ceil(pl / 5) - 1;

      return callback(status, { pl, ppl, centerResponse });
    });
  },
  updateCenter: (page = 0, count = 20, callback = null) => {
    const begin = page * 20;
    const end = begin + count;
    let centerResponse = [];

    // console.log('updateCenter - Center.centers.length - ' + Center.centers.length);
    // console.log('updateCenter - centerResponse.length - ' + centerResponse.length);

    centerResponse = Center.centers.slice(begin, end);
    Center.position = page;
    Center.boundLength = centerResponse.length ? centerResponse.length : 0;

    // console.log('updateCenter - page - ' + page);
    // console.log('updateCenter - count - ' + count);
    // console.log('updateCenter - begin - ' + begin);
    // console.log('updateCenter - end - ' + end);
    // console.log('updateCenter - Center.centers.length - ' + Center.centers.length);
    // console.log('updateCenter - centerResponse.length - ' + centerResponse.length);

    if (callback) {
      return callback(centerResponse);
    }
  },
  getBoundCenter: (start = 20, finish = 20) => {
    const begin = Center.position * start;
    const end = begin + finish;

    return Center.centers.length ? Center.centers.slice(begin, end) : [];
  },
  getBoundRect: (bound) => {
    /* eslint-disable */
    const n = bound._ne.y;
    const e = bound._ne.x;
    const s = bound._sw.y;
    const w = bound._sw.x;
    /* eslint-enable */

    const x = w;
    const y = s;
    const centerX = (w + e) / 2;
    const centerY = (s + n) / 2;
    const width = e - w;
    const height = n - s;

    return {
      x, y, width, height, centerX, centerY,
    };
  },
};

export default Center;
